import { get } from '../helpers/objectHelper';

/**
* Calculates total based on day price and pax count and bed/room
*
* @param {number} paxCount - number of passengers
* @param {number} dayPrice - day price of 
* @param {number} nights - number of nights
*/
export const calculateBedOrRoomTotal = (type, paxCount, dayPrice, nights) => {

    if(type === 'dorm'){
        return parseFloat(dayPrice * nights * paxCount).toFixed(2); 
    }

    if(type === 'hotel' || type === 'private'){
      const numberOfRoomsNeeded = Math.round(paxCount / 2);  //pax count / 2 (2 pax per room)
      return parseFloat((numberOfRoomsNeeded * dayPrice) * nights).toFixed(2); 
    }
}

/**
* Helper reservation daa
*
* @param {object} data - the current accommodation object
* @param {number} paxNumber - number of passengers
*/
export const reservationData = (data, paxNumber) => {

    const _type = get(['accommodation', 'reservations', 0, 'type'], data, "");
    const _beds = get(['accommodation', 'reservations', 0, 'beds'], data, "");
    const _rooms = get(['accommodation', 'reservations', 0, 'rooms'], data, "");
    const _pricePerNight = get(['accommodation', 'reservations', 0, 'pricePerNight'], data, 0);

    return {
        backstop: get(['accommodation', 'reservations', 0, 'isBackstop'], data, false),
        total: get(['accommodation', 'reservations', 0, 'total'], data, 0),
        beds: _beds,
        rooms: _rooms,
        nights: get(['accommodation', 'reservations', 0, 'nights'], data, ""),
        type:_type,
        dormOrRoomAmount: _type === "dorm" ? _beds : _rooms,
        dormOrRoomText: _type === "dorm" ? 'bed' : 'room',
        pricePerNight: _type === "dorm" ? (paxNumber * _pricePerNight).toFixed(2) : (_rooms * _pricePerNight).toFixed(2)
    }
}


